"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualIncomeRangeInThousandEuro = void 0;
var AnnualIncomeRangeInThousandEuro;
(function (AnnualIncomeRangeInThousandEuro) {
    AnnualIncomeRangeInThousandEuro[AnnualIncomeRangeInThousandEuro["Under_18"] = 1] = "Under_18";
    AnnualIncomeRangeInThousandEuro[AnnualIncomeRangeInThousandEuro["Between_18And_30"] = 2] = "Between_18And_30";
    AnnualIncomeRangeInThousandEuro[AnnualIncomeRangeInThousandEuro["Between_30And_50"] = 3] = "Between_30And_50";
    AnnualIncomeRangeInThousandEuro[AnnualIncomeRangeInThousandEuro["Between_50And_80"] = 4] = "Between_50And_80";
    AnnualIncomeRangeInThousandEuro[AnnualIncomeRangeInThousandEuro["Between_80And_120"] = 5] = "Between_80And_120";
    AnnualIncomeRangeInThousandEuro[AnnualIncomeRangeInThousandEuro["Over_120"] = 6] = "Over_120";
})(AnnualIncomeRangeInThousandEuro || (exports.AnnualIncomeRangeInThousandEuro = AnnualIncomeRangeInThousandEuro = {}));
//# sourceMappingURL=AnnualIncomeRangeInThousandEuro.js.map